import styled from 'styled-components';
import ReviewLiveSvg from '../../assets/mytrips/review-is-live.svg';

const ReviewLiveIcon = styled(ReviewLiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ReviewLiveIcon;
